import { useEffect } from 'react';

import clsx from 'clsx';
import { FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import TutorialLegend from '@event/components/TutorialModal';
import useRandomizedContent from '@event/hooks/useRandomizedContent';
import useEventTypesStore from '@event/store/useEventTypesStore';
import { useTutorialStore } from '@event/store/useTutorialStore';
import { CreateEvent } from '@event/types';
import useClientStore from '@utils/hooks/useClientStore';

import Location from './Location';

interface LocationSelectionProps {
  register: UseFormRegister<CreateEvent>;
  setValue: UseFormSetValue<CreateEvent>;
  formState: FormState<CreateEvent>;
  isTutorialEventLocation?: boolean;
}

const LocationSelection = ({
  register,
  setValue,
  formState,
  isTutorialEventLocation = false,
}: LocationSelectionProps) => {
  const { selectedEventType } = useEventTypesStore();
  const { eventTitle, eventDescription } = useRandomizedContent(
    selectedEventType,
    formState.isDirty,
  );

  const tutorialStore = useClientStore(useTutorialStore, (state) => state);

  useEffect(() => {
    setValue('description', eventDescription);
    setValue('name', eventTitle);
  }, [eventDescription, eventTitle, setValue]);

  return (
    <div
      className={clsx(
        'mb-4',
        isTutorialEventLocation &&
          'relative z-20 rounded-[16px] bg-brand-white-100',
      )}
    >
      {isTutorialEventLocation && (
        <TutorialLegend
          textBubble="Pokud už víte, kde se chcete setkat, můžete to ostatním sdělit."
          textHeadingCounter="4/5"
          textHeading="Místo konání události."
          onSubmit={() => {
            tutorialStore?.goToNextStep();
          }}
          className="bottom-[-378px] left-0"
        />
      )}
      <Location
        id={'location'}
        register={register}
        setValue={setValue}
        value="Ještě upřesníme, ale užijeme si to kdekoliv"
        classNameWrapper="mt-2"
        placeholder="Dobrá, na místě se tedy domluvíte později."
        isTutorialEventLocation={isTutorialEventLocation}
      />
    </div>
  );
};

export default LocationSelection;
